'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMatch = undefined;

var _rules;

var _tokenizer = require('../tokenizer');

var _tokenizer2 = _interopRequireDefault(_tokenizer);

var _parser = require('../parser');

var _parser2 = _interopRequireDefault(_parser);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

const rules = (_rules = {}, _defineProperty(_rules, 1, {
  type: 'root',
  re: /^\$/
}), _defineProperty(_rules, 2, {
  type: 'dot',
  re: /^\.(?!\.)/
}), _defineProperty(_rules, 3, {
  type: 'wildcard',
  re: /^\*/
}), _defineProperty(_rules, 4, {
  type: 'recurse',
  re: /^\.{2}/,
  parse: function recurse(acc, _ref, i, arr) {
    let value = _ref.value;

    const next = arr[i + 1];
    if (next && next.type === 'prop') return acc.concat(function (_ref2) {
      let data = _ref2.data,
          path = _ref2.path,
          withPaths = _ref2.withPaths;

      const d = data.map(function (x) {
        const result = (0, _utils.searchFor)(x, next.value);
        return result.length ? result : void 0;
      });
      return {
        data: d,
        path: withPaths ? path.chain(function (p) {
          return d.chain(function (_) {
            return data.map(function (x) {
              return (0, _utils.join)((0, _utils.searchForPath)(x, next.value), p);
            });
          });
        }) : path,
        withPaths: withPaths
      };
    });else return acc;
  }
}), _defineProperty(_rules, 5, {
  type: 'prop',
  re: /^([_\-A-Za-z][^.|[|<|{]*)/,
  parse: function prop(acc, _ref3, i, arr) {
    let value = _ref3.value;

    let offset = 1;
    let prev = arr[i - offset];
    if (prev && prev.type === 'recurse') return acc;
    prev = prev || { type: null };

    while (prev.type === 'dot') {
      prev = arr[i - ++offset];
    }

    const ignored = ['union', 'array'];

    const getProps = function (x) {
      return Array.isArray(x) ? (0, _utils.mapFilter)(function (y) {
        return y[value];
      })(x) : x[value];
    };

    const getPaths = function (x) {
      return Array.isArray(x) && !ignored.includes(prev.type) ? (0, _utils.join)([[value]], (0, _utils.pathFilter)(function (y) {
        return y[value];
      })(x)) : [[value]];
    };

    return acc.concat(function (_ref4) {
      let data = _ref4.data,
          path = _ref4.path,
          withPaths = _ref4.withPaths;

      const d = data.map(getProps);
      return {
        data: d,
        path: withPaths ? path.chain(function (p) {
          return d.chain(function (_) {
            return data.map(function (x) {
              return (0, _utils.join)(getPaths(x), p);
            });
          });
        }) : path,
        withPaths: withPaths
      };
    });
  }
}), _defineProperty(_rules, 7, {
  type: 'array',
  re: /^\[([^\]]+)\]/,
  map: function (m) {
    return (0, _tokenizer2.default)(m[1]);
  },
  parse: function array(acc, _ref5, i, arr) {
    let value = _ref5.value;

    const prev = arr[i - 1];
    const output = (0, _parser2.default)([{ type: prev.type, parse: _utils.Identity }].concat(_toConsumableArray(value)));
    return acc.concat.apply(acc, _toConsumableArray(output));
  }
}), _defineProperty(_rules, 9, {
  type: 'expr',
  re: /^\(([^$]+)\)/,
  map: function (m) {
    return m[1];
  },
  parse: function expr(acc, _ref6) {
    let value = _ref6.value;

    const fn = new Function('y', 'return ' + value.replace(/@/g, 'y'));
    return acc.concat(function (_ref7) {
      let data = _ref7.data,
          path = _ref7.path,
          withPaths = _ref7.withPaths;

      const d = data.map(function (x) {
        return x[fn(x)];
      });
      return {
        data: d,
        path: withPaths ? path.chain(function (p) {
          return d.chain(function (_) {
            return data.map(function (x) {
              return (0, _utils.join)([[fn(x)]], p);
            });
          });
        }) : path,
        withPaths: withPaths
      };
    });
  }
}), _defineProperty(_rules, 11, {
  type: 'mexpr',
  re: /^!\(([^$]+)\)/,
  map: function (m) {
    return m[1];
  },
  parse: function mexpr(acc, _ref8) {
    let value = _ref8.value;

    const fn = new Function('y', 'return ' + value.replace(/@/g, 'y'));

    const getProps = function (x) {
      return Array.isArray(x) ? x.map(function (y, i) {
        return fn(y);
      }) : fn(x);
    };

    return acc.concat(function (_ref9) {
      let data = _ref9.data,
          path = _ref9.path,
          withPaths = _ref9.withPaths;
      return {
        data: data.map(getProps), path: path, withPaths: withPaths
      };
    });
  }
}), _defineProperty(_rules, 13, {
  type: 'fexpr',
  re: /^\?\(([^$]+)\)/,
  map: function (m) {
    return m[1];
  },
  parse: function fexpr(acc, _ref10) {
    let value = _ref10.value;

    const fn = new Function('y', 'return ' + value.replace(/@/g, 'y'));
    return acc.concat(function (_ref11) {
      let data = _ref11.data,
          path = _ref11.path,
          withPaths = _ref11.withPaths;

      const d = data.map(function (x) {
        return x.filter(fn);
      });
      return {
        data: d,
        path: withPaths ? path.chain(function (p) {
          return d.chain(function (_) {
            return data.map(function (x) {
              return (0, _utils.join)((0, _utils.pathFilter)(fn)(x), p);
            });
          });
        }) : path,
        withPaths: withPaths
      };
    });
  }
}), _defineProperty(_rules, 15, {
  type: 'coerce',
  re: /^<(String|Number|int|float)>$/,
  map: function (m) {
    return m[1];
  },
  parse: function coerce(acc, _ref12) {
    let value = _ref12.value;

    let fn;
    switch (value) {
      case 'String':
        fn = String;
        break;
      case 'Number':
        fn = Number;
        break;
      case 'int':
        fn = function (x) {
          return parseInt(x, 10);
        };
        break;
      case 'float':
        fn = parseFloat;
        break;
    }
    const getProps = function (x) {
      return Array.isArray(x) ? x.map(fn) : fn(x);
    };

    return acc.concat(function (_ref13) {
      let data = _ref13.data,
          path = _ref13.path,
          withPaths = _ref13.withPaths;
      return {
        data: data.map(getProps), path: path, withPaths: withPaths
      };
    });
  }
}), _defineProperty(_rules, 17, {
  type: 'slice',
  re: /^(-?(?:0|[1-9][0-9]*))?:(-?(?:0|[1-9][0-9]*))?(:(-?(?:0|[1-9][0-9]*))?)?/,
  map: function (m) {
    return {
      start: Number(m[1] || '0'),
      end: Number(m[2]),
      step: Number((m[3] || ':1').slice(1))
    };
  },
  parse: function slice(acc, _ref14) {
    let value = _ref14.value;

    // TODO: Support step option
    const args = [value.start];
    if (value.end) args.push(value.end);
    return acc.concat(function (_ref15) {
      let data = _ref15.data,
          path = _ref15.path,
          withPaths = _ref15.withPaths;
      return {
        data: data.map(function (x) {
          return x.slice.apply(x, args);
        }),
        path: withPaths ? path.chain(function (p) {
          return data.map(function (x) {
            return (0, _utils.join)(_utils.slicePaths.apply(undefined, [x].concat(args)), p);
          });
        }) : path,
        withPaths: withPaths
      };
    });
  }
}), _defineProperty(_rules, 22, {
  type: 'union',
  re: /^((0|[1-9][0-9]*),?)+/,
  map: function (m) {
    return m[0].split(',').filter(_utils.Identity).map(Number);
  },
  parse: function union(acc, _ref16) {
    let value = _ref16.value;

    return acc.concat(function (_ref17) {
      let data = _ref17.data,
          path = _ref17.path,
          withPaths = _ref17.withPaths;

      const d = data.map(function (x) {
        return value.map(function (y) {
          return x[y];
        });
      });
      return {
        data: d,
        path: withPaths ? path.chain(function (p) {
          return d.map(function (_) {
            return (0, _utils.join)(value.map(function (x) {
              return [x];
            }), p);
          });
        }) : path,
        withPaths: withPaths
      };
    });
  }
}), _defineProperty(_rules, 25, {
  type: 'member',
  re: /^(?:['|"](?:[^'|"]+)['|"],?\s?)+/,
  map: function (m) {
    return m[0].split(',').filter(_utils.Identity).map(function (x) {
      return x.trim().slice(1, -1);
    });
  },
  parse: function member(acc, _ref18, i, arr) {
    let value = _ref18.value;

    const prev = arr[i - 1];

    const getProps = function (x) {
      return Array.isArray(x) ? x.map(function (y) {
        return value.reduce(function (acc, z) {
          return acc.push(y[z]), acc;
        }, []);
      }) : value.reduce(function (acc, z) {
        return acc.push(x[z]), acc;
      }, []);
    };

    const getPaths = function (x) {
      return Array.isArray(x) && prev.type !== 'array' ? (0, _utils.join)(value.map(function (x) {
        return [x];
      }), Array.from(x, function (_, i) {
        return [i];
      })) : value.map(function (x) {
        return [x];
      });
    };

    return acc.concat(function (_ref19) {
      let data = _ref19.data,
          path = _ref19.path,
          withPaths = _ref19.withPaths;

      const d = data.map(getProps);
      return {
        data: d,
        path: withPaths ? path.chain(function (p) {
          return d.chain(function (_) {
            return data.map(function (x) {
              return (0, _utils.join)(getPaths(x), p);
            });
          });
        }) : path,
        withPaths: withPaths
      };
    });
  }
}), _defineProperty(_rules, 26, {
  type: 'omember',
  re: /^\{(?:['|"](?:[^'|"]+)['|"],?\s?)+\}/,
  map: function (m) {
    return m[0].slice(1, -1).split(',').filter(_utils.Identity).map(function (x) {
      return x.trim().slice(1, -1);
    });
  },
  parse: function omember(acc, _ref20, i, arr) {
    let value = _ref20.value;

    const prev = arr[i - 1];

    const getProps = function (x) {
      return Array.isArray(x) ? x.map(function (y) {
        return value.reduce(function (acc, z) {
          return acc[z] = y[z], acc;
        }, {});
      }) : value.reduce(function (acc, z) {
        return acc[z] = x[z], acc;
      }, {});
    };

    const getPaths = function (x) {
      return Array.isArray(x) && prev.type !== 'array' ? (0, _utils.join)(value.map(function (x) {
        return [x];
      }), Array.from(x, function (_, i) {
        return [i];
      })) : value.map(function (x) {
        return [x];
      });
    };

    return acc.concat(function (_ref21) {
      let data = _ref21.data,
          path = _ref21.path,
          withPaths = _ref21.withPaths;

      const d = data.map(getProps);
      return {
        data: d,
        path: withPaths ? path.chain(function (p) {
          return d.chain(function (_) {
            return data.map(function (x) {
              return (0, _utils.join)(getPaths(x), p);
            });
          });
        }) : path,
        withPaths: withPaths
      };
    });
  }
}), _rules);

const regexString = [];
for (let k in rules) {
  const re = rules[k].re;

  regexString.push('(' + re.source + ')');
}

const regex = new RegExp(regexString.join('|'));

exports.getMatch = getMatch;
exports.default = getMatch;


function getMatch(str) {
  const result = str.match(regex);
  const length = result[0].length;

  const index = result.slice(1).findIndex(_utils.Identity) + 1;
  const mapRes = result.slice(index);
  var _rules$index = rules[index];
  const type = _rules$index.type;
  var _rules$index$map = _rules$index.map;
  const map = _rules$index$map === undefined ? _utils.head : _rules$index$map;
  var _rules$index$parse = _rules$index.parse;
  const parse = _rules$index$parse === undefined ? _utils.Identity : _rules$index$parse;

  return {
    type: type,
    length: length,
    parse: parse,
    value: map(mapRes)
  };
}